(() => {
  'use strict';
  if (customElements.get('mykidss-welcome-drawer')) return;
  class MyKidssWelcomeDrawer extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.launcher = this.querySelector('[data-welcome-launcher]');
      this.dialog = this.querySelector('dialog');
      this.openButton = this.querySelector('[data-welcome-open]');
      this.form = this.querySelector('form');
      this.key = 'mk-welcome:' + this.dataset.locale;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      const stored = this.read('dismissed');
      this.dismissed = stored === '1' || this.read('subscribed') === '1';
      this.openButton.addEventListener('click', () => this.open(), {signal});
      this.querySelector('[data-welcome-dismiss]').addEventListener('click', () => {
        this.dismissed = true;
        this.write('dismissed', '1');
        this.update();
      }, {signal});
      this.querySelectorAll('[data-welcome-close]').forEach(button => button.addEventListener('click', () => this.close(), {signal}));
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const box = this.dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.close();
      }, {signal});
      this.dialog.addEventListener('close', () => {
        document.documentElement.style.overflow = this.previousOverflow || '';
        this.openButton.setAttribute('aria-expanded', 'false');
        this.update();
        if (!this.dismissed && !this.launcher.hidden) this.openButton.focus({preventScroll:true});
      }, {signal});
      this.form.addEventListener('submit', () => {
        this.write('pending', String(Date.now()));
        this.form.querySelector('button[type=submit]').disabled = true;
      }, {signal});
      this.schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = 0; this.update(); });
      };
      window.addEventListener('scroll', this.schedule, {passive:true, signal});
      window.addEventListener('resize', this.schedule, {passive:true, signal});
      window.addEventListener('pageshow', () => {
        const submit = this.form.querySelector('button[type=submit]');
        if (submit) submit.disabled = false;
        this.schedule();
      }, {signal});
      document.addEventListener('click', this.schedule, {signal});
      if (window.visualViewport) window.visualViewport.addEventListener('resize', this.schedule, {signal});
      this.observer = new MutationObserver(this.schedule);
      this.observer.observe(document.body, {attributes:true, attributeFilter:['class'], childList:true});
      this.update();
      const state = this.querySelector('[data-welcome-state]')?.dataset.welcomeState;
      const isReturn = new URLSearchParams(location.search).get('mk_newsletter') === '1' || Date.now() - Number(this.read('pending')) < 600000;
      if (state && isReturn) {
        if (state === 'success') {
          this.write('subscribed', '1');
          this.dismissed = true;
        }
        this.write('pending', '0');
        this.open();
      }
    }
    read(name) { try { return sessionStorage.getItem(this.key + ':' + name); } catch { return null; } }
    write(name, value) { try { sessionStorage.setItem(this.key + ':' + name, value); } catch {} }
    visible(element) {
      if (!element) return false;
      const box = element.getBoundingClientRect();
      const style = getComputedStyle(element);
      return box.width > 0 && box.height > 0 && style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
    }
    blocked() {
      if (document.body.classList.contains('no-scroll')) return true;
      return Array.from(document.querySelectorAll('dialog[open], [role="dialog"][aria-modal="true"], .modal-drawer-panel.active, .modal-drawer-panel.open, .side-drawer-panel.active, #pandectes-banner, #pandectes-banner-container')).some(element => element !== this.dialog && this.visible(element));
    }
    update() {
      if (!this.isConnected) return;
      const main = document.querySelector('#MainContent');
      if (!main) return;
      const rect = main.getBoundingClientRect();
      const available = Math.max(1, rect.height - innerHeight);
      const progress = Math.max(0, -rect.top) / available;
      const footer = document.querySelector('footer.footer');
      const atFooter = footer && footer.getBoundingClientRect().top < innerHeight;
      const keyboard = window.visualViewport && window.visualViewport.height < innerHeight * .72;
      const show = progress >= Number(this.dataset.threshold) / 100 && !this.dismissed && !atFooter && !keyboard && !this.dialog.open && !this.blocked();
      this.launcher.hidden = !show;
      const sticky = document.querySelector('.mykidss-pdp-sticky.is-visible');
      const preview = document.querySelector('#PBarNextFrame');
      const previewLift = this.visible(preview) ? 76 : 0;
      const lift = (this.visible(sticky) ? sticky.getBoundingClientRect().height : 0) + previewLift;
      const value = Math.round(lift) + 'px';
      if (this.style.getPropertyValue('--mk-welcome-lift') !== value) this.style.setProperty('--mk-welcome-lift', value);
    }
    open() {
      if (this.dialog.open || this.blocked()) return;
      this.previousOverflow = document.documentElement.style.overflow;
      this.dialog.showModal();
      document.documentElement.style.overflow = 'hidden';
      this.openButton.setAttribute('aria-expanded', 'true');
      this.launcher.hidden = true;
      const result = this.querySelector('[data-welcome-state="success"]');
      if (result) result.focus({preventScroll:true});
    }
    close() { if (this.dialog.open) this.dialog.close(); }
    disconnectedCallback() {
      if (this.dialog?.open) this.close();
      this.abort?.abort();
      this.observer?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
    }
  }
  customElements.define('mykidss-welcome-drawer', MyKidssWelcomeDrawer);
})();
